import {queryService} from "@mytour/platform";
import * as Sentry from "@sentry/react";
import {QueryClientProvider} from "@tanstack/react-query";
import "app/App.scss";
import "app/App2.scss";
import {RouterProvider} from "react-router";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {AnalyticsContainer} from "./AnalyticsContainer";
import {SentryContainer} from "./SentryContainer";
import {createAppRouter} from "./routes/AppRoutes";

const router = createAppRouter();

export const App = () => {
  return (
    <Sentry.ErrorBoundary>
      <QueryClientProvider client={queryService.getQueryClient()}>
        <ToastContainer
          position={"top-left"}
          theme="colored"
          className="toastify-container"
          toastClassName="toastify-toast"
        />
        <RouterProvider router={router} />
        <SentryContainer />
        <AnalyticsContainer />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
};
